export default "__VITE_ASSET__8c68f43a__"